module.exports = __webpack_public_path__ + "static/artist-development-results-mobile-d9ba15cef8b4467c4fea544c7fd56779.png";